(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/internal/account-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/internal/account-selector.js');

'use strict';

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  refreshQueryString,
  currentPathEncodedParams,
  updateQueryStringParameter
} = svs.utils.url;
const {
  CurrencyFromJupiterString: currencyFromJupiterString
} = svs.utils.format;
const logger = new svs.core.log.Logger('numbergames:account_selector');
const {
  AccountSelectorError
} = svs.numbergames.accountSelector;
const {
  events: {
    FETCHED,
    ACTIVE_ACCOUNT_CHANGED,
    ACCOUNT_BALANCE_UPDATED
  },
  errors: {
    INVALID_ARGUMENTS,
    INVALID_ACCOUNT_SELECTED,
    UNKNOWN
  },
  errorMessages
} = svs.numbergames.accountSelector.constants;
const PARAM_NAME = 'syndicateId';
const SPELKONTO_ID = 'SPELKONTO';
class AccountSelector {
  constructor() {
    _defineProperty(this, "playerAccount", null);
    _defineProperty(this, "syndicates", null);
    _defineProperty(this, "accountBalanceUpdateListener", null);
    _defineProperty(this, "selectedAccountIndex", 0);
  }
  listenTo(listeners, context) {
    Object.keys(listeners).forEach(key => {
      this.on(key, listeners[key], context);
    });
  }
  stopListeningTo(listeners) {
    Object.keys(listeners).forEach(key => {
      this.off(key, listeners[key]);
    });
  }
  listenForAccountBalanceComponentUpdates() {
    if (!this.accountBalanceUpdateListener) {
      this.accountBalanceUpdateListener = balance => {
        try {
          this.updateAccountBalance({
            accountId: SPELKONTO_ID,
            balance
          });
        } catch (error) {
          logger.error("Got updated account balance from account_balance component but could not update, new balance was: ".concat(balance), error);
        }
      };
      svs.components.account_balance.on('change', this.accountBalanceUpdateListener);
    }
  }
  fetchPlayerAccount() {
    let {
      refetch
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!refetch && this.fetchAccountPromise) {
      return this.fetchAccountPromise;
    }
    this.fetchAccountPromise = new Promise(resolve => {
      svs.components.account_balance.get(balance => {
        this.playerAccount = [{
          id: SPELKONTO_ID,
          name: 'Mitt saldo',
          balance: currencyFromJupiterString(balance),
          isSyndicate: false
        }];
        this.listenForAccountBalanceComponentUpdates();
        resolve(this.playerAccount);
      });
    });
    return this.fetchAccountPromise;
  }
  async fetchSyndicates() {
    let {
      refetch
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!refetch && this.fetchSyndicatesPromise) {
      return this.fetchSyndicatesPromise;
    }
    try {
      this.fetchSyndicatesPromise = svs.core.jupiter.callAsync({
        method: 'GET',
        path: '/social/2/syndicates'
      });
      const {
        response: {
          customerSyndicates
        }
      } = await this.fetchSyndicatesPromise;
      this.syndicates = customerSyndicates.map(_ref => {
        let {
          syndicateId: id,
          playableAmount,
          syndicateName: name,
          memberRole,
          adminManagedWagers
        } = _ref;
        return {
          id: String(id),
          name,
          balance: currencyFromJupiterString(playableAmount),
          isSyndicate: true,
          isPermissionBlocked: adminManagedWagers && memberRole < 6 
        };
      });
    } catch (err) {
      logger.error('Could not retrieve list of syndicates from api', err);
    }
    return this.fetchSyndicatesPromise;
  }
  async fetch() {
    let {
      refetch = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      accounts: [],
      selectedAccount: SPELKONTO_ID,
      selectedAccountChanged: false
    };
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      let selectedAccountChanged = false;
      try {
        await Promise.all([this.fetchSyndicates({
          refetch
        }), this.fetchPlayerAccount({
          refetch
        })]);
        const accounts = await this.getAccounts();
        const syndicateParam = svs.utils.paramHandler.get({
          key: 'syndicateId'
        }).value;
        if (syndicateParam) {
          const index = accounts.findIndex(_ref2 => {
            let {
              id
            } = _ref2;
            return id === syndicateParam;
          });
          if (index >= 0) {
            this.selectedAccountIndex = index;
          } else {
            selectedAccountChanged = true;
            svs.utils.paramHandler.remove({
              key: PARAM_NAME
            });
          }
        }
        const selectedAccount = await this.getActiveAccount();
        const result = {
          accounts,
          selectedAccount: selectedAccount.id,
          selectedAccountChanged
        };
        this.trigger(FETCHED, result);
        if (this.selectedAccountIndex) {
          this.trigger(ACTIVE_ACCOUNT_CHANGED, syndicateParam);
        }
        return result;
      } catch (err) {
        logger.error('Could not retrieve list of syndicates from api', err);
        return defaults;
      }
    }
    return defaults;
  }
  getError(type, message) {
    switch (type) {
      case INVALID_ACCOUNT_SELECTED:
        return new AccountSelectorError({
          type,
          message: message || errorMessages[INVALID_ACCOUNT_SELECTED]
        });
      case INVALID_ARGUMENTS:
        return new AccountSelectorError({
          type,
          message: message || errorMessages[INVALID_ARGUMENTS]
        });
      default:
        return new AccountSelectorError({
          type: UNKNOWN,
          message: message || errorMessages[INVALID_ACCOUNT_SELECTED]
        });
    }
  }
  isInitialized() {
    return this.syndicates && this.playerAccount;
  }
  async getAccounts() {
    if (!this.isInitialized()) {
      await this.fetch();
    }
    return [...this.playerAccount, ...this.syndicates];
  }
  async getActiveAccount() {
    if (!this.isInitialized()) {
      if (svs.utils.url.queryString[PARAM_NAME]) {
        const fetchResult = await this.fetch();
        if (fetchResult.selectedAccountChanged) {
          throw this.getError(INVALID_ACCOUNT_SELECTED);
        }
      } else {
        const accounts = await this.fetchPlayerAccount();
        return accounts[this.selectedAccountIndex];
      }
    }
    const accounts = await this.getAccounts();
    return accounts[this.selectedAccountIndex];
  }
  async usePlayerAccount() {
    return this.setActiveAccount(SPELKONTO_ID);
  }
  async findAccount(accountId) {
    let accounts;
    let index;
    let account;
    if (accountId === SPELKONTO_ID) {
      index = 0;
      account = await this.fetchPlayerAccount();
      account = account[0];
      if (this.isInitialized()) {
        accounts = await this.getAccounts();
      }
    } else {
      accounts = await this.getAccounts();
      index = accounts.findIndex(_ref3 => {
        let {
          id
        } = _ref3;
        return id === "".concat(accountId);
      });
      if (index >= 0) {
        account = accounts[index];
      }
    }
    return {
      account,
      accounts,
      index
    };
  }
  async setActiveAccount(accountId) {
    if (accountId === undefined) {
      throw this.getError(INVALID_ARGUMENTS, 'Call to setActiveAccount is missing accountId');
    }
    if (Number.isInteger(accountId)) {
      accountId = "".concat(accountId);
    }
    const {
      account,
      index
    } = await this.findAccount(accountId);
    if (!account) {
      throw this.getError(INVALID_ACCOUNT_SELECTED);
    }
    if (account.isSyndicate) {
      refreshQueryString();
      let targetPath = currentPathEncodedParams();
      targetPath = updateQueryStringParameter(targetPath, PARAM_NAME, accountId);
      window.history.replaceState({}, '', targetPath);
    } else {
      svs.utils.paramHandler.remove({
        key: PARAM_NAME
      });
    }
    this.selectedAccountIndex = index;
    this.trigger(ACTIVE_ACCOUNT_CHANGED, accountId);
    return account;
  }
  async updateAccountBalance() {
    let {
      accountId,
      balance
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (accountId === undefined || balance === undefined) {
      throw this.getError(INVALID_ARGUMENTS, "Call to setActiveAccount is missing".concat(accountId === undefined ? ' accountId' : '').concat(balance === undefined ? ' balance' : ''));
    }
    if (typeof balance !== 'number') {
      const origialBalance = balance;
      balance = currencyFromJupiterString(balance);
      if (isNaN(balance)) {
        throw this.getError(INVALID_ARGUMENTS, "Cannot update account balance as new balance was not a valid number: ".concat(origialBalance));
      }
    }
    const {
      account,
      accounts
    } = await this.findAccount(accountId);
    if (!account) {
      throw this.getError(INVALID_ACCOUNT_SELECTED);
    }
    if (account.balance !== balance) {
      account.balance = balance;
      this.trigger(ACCOUNT_BALANCE_UPDATED, {
        account,
        accounts
      });
    }
    return account;
  }
}
svs.numbergames.accountSelector._internal.AccountSelector = AccountSelector;

 })(window);